import { render } from "./UserName.vue?vue&type=template&id=59f37ac7&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import "./UserName.vue?vue&type=style&index=0&id=59f37ac7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f37ac7"]])

export default __exports__